// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/views/Dimension/components/WoodConnectionBracket/styles.scss
// module id = 1309
// module chunks = 0